import VideoSection from './VideoSection';

export default VideoSection;
